// Shared constants of the FAQ page (kept out of the component files).
export const PAGE_SIZE = 20
export const SEARCH_DEBOUNCE_MS = 300
export const NO_FILTERS = { q: '', group_id: '', source: '', sync_status: '' }
export const UNGROUPED = 'none'
export const SOURCES = ['manual', 'excel', 'website', 'bot_log', 'legacy_doc', 'quick_answer']
// Written by a Quick Answer: edited on the Quick Answer page, read-only here.
export const MIRROR_SOURCE = 'quick_answer'
export const SYNC_STATUSES = ['synced', 'pending', 'syncing', 'failed']

// "Nguồn" lists the sources the tenant has, plus manual and Excel always, and
// the ones whose feature is switched on.
export function sourceOptions(bySource = {}, capabilities = {}) {
  return SOURCES.filter((source) => (
    source === 'manual' || source === 'excel' || (bySource[source] || 0) > 0
    || (source === 'website' && capabilities.website_collect)
    || (source === 'bot_log' && capabilities.bot_log)
  ))
}

// Export file name when the browser may not read the server's one: faq-20261013.xlsx, in local time.
export function exportFallbackName(now = new Date()) {
  const pad = (value) => String(value).padStart(2, '0')
  return `faq-${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}.xlsx`
}
